import { isClientDeploymentEnv } from '@reward-platform/utils'

export const isClient = () => typeof window !== 'undefined'
export const isServer = () => typeof window === 'undefined'

// Deployment Environment
export const isProduction = () => isClientDeploymentEnv('prd')
export const isStaging = () => isClientDeploymentEnv('stg')
export const isTest = () => isClientDeploymentEnv('tst')
export const isDevelopment = () => isClientDeploymentEnv('dev')
export const isLocal = () => isClientDeploymentEnv('local')

// Application Environment
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isCypress = () => isClient() && !!(window as any)?.Cypress
